import axios from "./axiosinstance";

const LeadAssignApi = {
  list: () => axios.get("leadAssigns/list"),
  add: (payload) => axios.post("leadAssigns/add", payload),
  update: (payload) => axios.post("leadAssigns/update", payload),
  delete: (payload) => axios.post("leadAssigns/delete", payload),
};

export default LeadAssignApi;